import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Report } from '../../../models/report.model';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-les-plus-read-mode',
  templateUrl: './les-plus-read-mode.component.html',
  styleUrls: ['./les-plus-read-mode.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule],
})
export class LesPlusReadModeComponent {
  @Input() perks!: Report.Perk;
}
